import React, { FC, useCallback, ReactNode } from 'react';
import { DnDFiles, makeFiles } from '@dynamika-shared/ui/DnDFiles/DnDFiles';
import { UploadBoxIcon } from '@dynamika-shared/ui/icons';
import { twJoin } from '../../utils/twMerge';

type UploadBoxViewProps = {
  className?: string;
  hasError?: boolean;
  onAttach: (file: File) => void;
  acceptFile?: string;
  description?: ReactNode;
};

export const UploadBoxView: FC<UploadBoxViewProps> = ({
  onAttach,
  hasError,
  acceptFile,
  className,
  description,
}) => {
  const handleFile = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      const files = makeFiles(e.target.files);
      if (files?.length) {
        onAttach(files[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <DnDFiles onFilesAdded={files => onAttach(files[0])}>
      {isDragActive => (
        <label
          className={twJoin(
            className,
            'border-pastelBlue flex cursor-pointer flex-col items-center justify-center rounded-sm border py-4 hover:bg-waterLight transition duration-300 hover:bg-opacity-50',
            isDragActive && 'border-vividTangelo opacity-30',
            hasError && 'border-vermilion border-solid',
            (!hasError || isDragActive) && 'border-dashed'
          )}
        >
          <div className=''>
            <div className='mb-1 flex h-[8rem] w-[8rem] items-center justify-center rounded-full border-2 border-vividTangelo'>
              <UploadBoxIcon className='h-4 w-4' />
            </div>
          </div>
          <div className='w-[25rem] text-center'>
            {description}
            <input
              className='hidden'
              type='file'
              accept={acceptFile}
              onChange={handleFile}
            />
          </div>
        </label>
      )}
    </DnDFiles>
  );
};
